import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-it-staffing',
  templateUrl: './it-staffing.component.html',
  styleUrl: './it-staffing.component.css'
})
export class ItStaffingComponent {
  baseUrl = Constants.baseUrl;
  isBrowser:boolean=false;
  constructor( private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,private _renderer2: Renderer2,
  @Inject(DOCUMENT) private _document: Document,
  private seoService:SeoService,
  private metaService: Meta) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.setTitleAndMetaTags();
    let script = this._renderer2.createElement('script');
  script.type = `application/ld+json`;
  script.text = `
  {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/technology-staffing/"
  },
  "headline": "Staffing Services | Maganti IT",
  "description": "We connect businesses with Application modernization extraordinaire who have the technical, functional, and product expertise to deliver application and systems modernization solutions to our clients.",
  "image": "https://mitresource.com/assets/images/techstaffing-images/applicationmodernization.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-28"
}
`;
  this._renderer2.appendChild(this._document.body, script);
    if(this.isBrowser){     
      AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
      AOS.init({
        once: true, 
      });
    }
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Staffing Services');
    this.metaService.addTags([
      { name: 'description', content: 'We connect businesses with Application modernization extraordinaire who have the technical, functional, and product expertise to deliver application and systems modernization solutions to our clients.' },
      { property: 'og:type', content: 'website' },
      { property: 'link:icon', content: '/assets/images/banners/mit-favicon.png' },
      { property: 'og:title', content: 'Staffing Services' },
      { property: 'og:url', content: 'https://mitresource.com/application-services/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/application/application-bulidimage.png' },
      { property: 'og:description', content: 'We connect businesses with Application modernization extraordinaire who have the technical, functional, and product expertise to deliver application and systems modernization solutions to our clients.' },
    ]);
  }
  activeTab = 'technical';

technicalRoles = [
  { title: 'Developers', description: 'Full-Stack, Backend, and Frontend (React, Angular, Node.js, Python, .NET, Java)' },
  { title: 'Mobile Engineers', description: 'OS, Android, Flutter, React Native' },
  { title: 'Cloud & Infrastructure', description: 'AWS, Azure, GCP Architects, DevOps Engineers, SREs' },
  { title: 'Data & AI', description: 'Data Engineers, Data Scientists, BI Developers, AI/ML Specialists, NLP Experts' },
  { title: 'Cybersecurity', description: 'Analysts, Security Engineers, and Architects' },
  { title: 'ERP Specialists', description: 'SAP, Oracle, Microsoft Dynamics' },
  { title: 'QA & Testing', description: 'Automation Testers, Manual Testers, Performance Engineers' },
  { title: 'Project & Product Management', description: 'Project Managers, Scrum Masters, Product Owners' },
  { title: 'Support & Systems', description: 'System Administrators, Network Engineers, Helpdesk, IT Support' }
];

corporateRoles = [
  'HR Generalists, HR Business Partners (HRBPs), DEI Specialists',
  'Talent Acquisition & Technical Recruiters',
  'Payroll & Benefits Administrators',
  'L&D Consultants, Change Managers, Compliance Analysts'
];

}